// Visual preview + description per design style.
// Used in CreateWizard Step 5 to help users pick.
export const DESIGN_STYLES = {
  none: {
    el: "Ουδέτερο — χωρίς προκαθορισμένο στυλ.",
    en: "Neutral — no stylistic preset.",
    preview: { bg: "#F9F8F6", fg: "#15251E", accent: "#244A36", label: "Aa", font: "serif" },
  },
  shruti: {
    el: "Ζωηρό, story-driven, lifestyle. Χρώματα φιλικά, εικόνες με ζεστασιά.",
    en: "Vibrant, story-driven lifestyle. Warm visuals.",
    preview: { bg: "#FDE7D9", fg: "#3A1F0E", accent: "#D4672E", label: "✨", font: "sans" },
  },
  hormozi: {
    el: "Συγκεκριμένα νούμερα, outcome-focused. Big bold type.",
    en: "Specific numbers, outcome-focused. Big bold type.",
    preview: { bg: "#0B0B0B", fg: "#FFEB00", accent: "#FFEB00", label: "$10K", font: "bold" },
  },
  gary_vee: {
    el: "High-energy, candid, motivational. Καθημερινή γλώσσα.",
    en: "High-energy, candid, motivational.",
    preview: { bg: "#2D1B4E", fg: "#FFD93D", accent: "#FF6B9D", label: "GO!", font: "bold" },
  },
  alex_catoni: {
    el: "Tactical copywriting, benefit-led. Καθαρά CTAs.",
    en: "Tactical copywriting, benefit-led.",
    preview: { bg: "#F5E6D3", fg: "#2A2520", accent: "#B8860B", label: "›", font: "serif" },
  },
  marie_forleo: {
    el: "Empowering, warm business voice. Γυναικεία επιχειρηματική ενέργεια.",
    en: "Empowering, warm business voice.",
    preview: { bg: "#FFD9E8", fg: "#2A0E1F", accent: "#E03B82", label: "♥", font: "sans" },
  },
  devin_jatho: {
    el: "Sales-forward, concise. Direct response copy.",
    en: "Sales-forward, concise direct-response.",
    preview: { bg: "#1A1A1A", fg: "#FFFFFF", accent: "#00D563", label: "SELL", font: "bold" },
  },
  dain_walker: {
    el: "Brand-led, premium, minimalist. Typography-first.",
    en: "Brand-led, premium, minimalist.",
    preview: { bg: "#EDEAE3", fg: "#1C1C1C", accent: "#C9A96E", label: "DW", font: "serif" },
  },
  chris_do: {
    el: "Thoughtful, educational, design-business. Logical flow.",
    en: "Thoughtful, educational, design-business.",
    preview: { bg: "#0A0A0A", fg: "#F05A28", accent: "#F05A28", label: "?!", font: "sans" },
  },
  marketing_harry: {
    el: "Tactical tips, practical. Λίστες + καθαρά takeaways.",
    en: "Tactical tips, practical takeaways.",
    preview: { bg: "#E8F3F0", fg: "#0D3B2E", accent: "#2BA876", label: "TIP", font: "sans" },
  },
  custom: {
    el: "Δικό σου στυλ — το AI ακολουθεί τη φωνή του brief.",
    en: "Your own voice — AI mirrors your brief.",
    preview: { bg: "#F9F8F6", fg: "#15251E", accent: "#244A36", label: "U", font: "serif" },
  },
};
